import { Promise as BluebirdPromise } from 'bluebird';
import cns from 'classnames';
import { get, isEmpty, isObject, keyBy } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import querystring from 'query-string';
import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import {
    getLocalStorage,
    getManyCollections,
    getManyPathways,
    getManyUserCollections,
    getManyUserEvents,
    getManyUserLearningAssets,
    getManyUserPathways,
    getPathway,
    getRecommendedAndAssignedCollections,
    getUserPathway,
    postNotes,
    postPeerRecommendations,
    postUserFeedback,
    postUserPathway,
    putUserPathway,
    setLocalStorage,
} from '../../../shared/actions/index';
import RecommendationModal from '../../../shared/components/modals/RecommendationModal';
import Page from '../../../shared/components/Page';
import VerbText from '../../../shared/components/VerbText';
import { DEFAULT_CUSTOM_HOME_PAGE, POPULAR_ON_PATHS_ROW, SEGMENT_EVENTS } from '../../../shared/Constants';
import {
    makeGetFilteredObjectsFromState,
    makeGetObjectsFromStateById,
    makeGetUserCollectionByUser,
    makeGetUserCollectionContent
} from '../../../shared/selectors/index';
import { getCompletionStatusForUserCollection } from '../../../shared/utils/UserLearningAssetUtils';
import ImproveSkillsWidget from '../../components/widgets/ImproveSkillsWidget/ImproveSkillsWidget';
import CollectionsHomeRow from './CollectionsHomeRow';
import DimensionsHomeRow from './DimensionsHomeRow';
import FeaturedCollectionRow from './FeaturedCollectionRow';
import FeedbackModule from './FeedbackModule';
import HomeWelcomeBanner from './HomeWelcomeBanner';
import PanelWidget from './PanelWidget';
import TeamsHomeRow from './TeamsHomeRow';
import { orderAccessor } from '../../../shared/utils/AccessorUtils';

class Home extends Component {
    static propTypes = {
        completedUserCollections: PropTypes.array,
        inProgressUserCollections: PropTypes.array,
        userCompany: PropTypes.object,
        userTeams: PropTypes.array,
        isVerbAdmin: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        loggedInUser: PropTypes.object,
        loggedInUserId: PropTypes.string,
        getManyCollections: PropTypes.func,
        getManyUserLearningAssets: PropTypes.func,
        getManyUserCollections: PropTypes.func,
        getManyUserEvents: PropTypes.func,
        postNotes: PropTypes.func,
        teamsById: PropTypes.object,
        collectionsById: PropTypes.object,
        postPeerRecommendations: PropTypes.func,
        pathwaysEnabled: PropTypes.bool,
        getManyPathways: PropTypes.func,
        getManyUserPathways: PropTypes.func,
        getPathway: PropTypes.func,
        getUserPathway: PropTypes.func,
        postUserPathway: PropTypes.func,
        putUserPathway: PropTypes.func,
        userCollectionsById: PropTypes.object,
        userPathways: PropTypes.array,
        frameworkDimensions: PropTypes.array,
        userCollectionsByCollectionId: PropTypes.object,
        collectionLoading: PropTypes.bool,
        history: PropTypes.object,
        isMobile: PropTypes.bool,
        getRecommendedAndAssignedCollections: PropTypes.func,
        recommendedAndAssignedCollections: PropTypes.array,
        userCollectionLoading: PropTypes.bool,
        postUserFeedback: PropTypes.func,
        userLearningAssetsById: PropTypes.object,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            isWelcome: false,
            collectionIdToRecommend: '',
            loading: true,
            displayFeedbackModule: false,
            feedbackPanelExtended: false,
            isAssignedRecommendedLoaded: false,
        };
        this.homeMainColumnRef = createRef()
    }

    showFeedbackModule = () => {
        const { loggedInUser } = this.props;
        const currentDate = new Date();
        const feedbackClosed = loggedInUser?.feedbackClosedOrSubmited || loggedInUser?.createdOn;
        const submitedDifference = moment(currentDate).diff(moment(feedbackClosed), 'months', true);

        if (submitedDifference >= 3) {
            this.setState({
                displayFeedbackModule: true
            });
        }
    };

    handleFeedbackClose = () => {
        this.setState({
            displayFeedbackModule: false
        });
    };
o
    handleFeedbackExtended = (trueOrFalse) => {
        this.setState({
            feedbackPanelExtended: trueOrFalse
        });
    };

    _handleHomeDataResults = () => {
        const { isMobile, history } = this.props;
        // const { forceOpenPanel = '' } = querystring.parse(history.location.search);
        // if (forceOpenPanel) {
        //     setLocalStorage({
        //         key: 'isHomePageLearningPanelOpen',
        //         value: true,
        //         dispatchDisabled: true
        //     });
        // }
        // const isHomePageLearningPanelOpen =
        //     forceOpenPanel === 'true' ||
        //     getLocalStorage({ key: 'isHomePageLearningPanelOpen', dispatchDisabled: true });
        this.setState({
            loading: false,
            // isHomePageLearningPanelOpen,
            currentWidth: window.outerWidth
        });
        if (!isMobile) {
            // document.body.style.overflowY = !isHomePageLearningPanelOpen ? 'auto' : 'hidden';
            document.body.style.overflowY = 'auto';
        }
    };

    componentDidMount() {
        const { userCollectionsByCollectionId = {}, loggedInUserId, collectionsById = {}, loggedInUser } = this.props;
        const welcome = get(this.props, 'match.params.welcome', '');
        window.addEventListener('resize', this.resize);
        this.setState({
            loading: true,
            isWelcome: welcome
        });
        if (!isEmpty(userCollectionsByCollectionId) && !isEmpty(collectionsById)) {
            this.props.getRecommendedAndAssignedCollections({ pathsContext: this.context.pathsWeb })
            return this._handleHomeDataResults();
        }

        if (this.homeMainColumnRef.current) {
            this.observer = new MutationObserver(
                (mutationList) => {
                    mutationList.forEach((mutation) => {
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach((node) => {
                                if (node.classList && node.classList.contains('ASSIGNED_AND_RECOMMENDED')) {
                                    this.setState({ isAssignedRecommendedLoaded: true });
                                    this.observer.disconnect()
                                }
                            })
                        }
                    })
                },
            );
            this.observer.observe(this.homeMainColumnRef.current, { childList: true, subtree: true })
        }

        return this._getHomeData().then(this._handleHomeDataResults, this.showFeedbackModule());
    }

    componentDidUpdate(prevProps) {
        const { loggedInUser } = this.props;
        // eslint-disable-next-line prettier/prettier
        if ((!prevProps.loggedInUser || !prevProps.loggedInUser._id) && loggedInUser && loggedInUser._id) {
            this.showFeedbackModule();
            return this._getHomeData();
        }
        return null;
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
        window.removeEventListener('resize', this.resize);
        document.body.style.overflowY = 'auto';
    }

    resize = () => {
        this.setState({
            currentWidth: window.outerWidth
        });
    };

    _closeBanner = () => {
        this.setState({ isWelcome: false });
    };

    _getHomeData = () => {
        const {
            getManyCollections,
            getManyUserLearningAssets,
            getManyUserCollections,
            loggedInUser,
            getRecommendedAndAssignedCollections
        } = this.props;

        const promises = [];

        if (isEmpty(loggedInUser)) {
            return BluebirdPromise.resolve();
        }

        promises.push(getManyUserLearningAssets({pathsContext: this.context.pathsWeb, userProfileId: loggedInUser._id }));
        promises.push(getManyUserCollections({pathsContext: this.context.pathsWeb, userProfileId: loggedInUser._id }));
        promises.push(
            getManyCollections({ pathsContext: this.context.pathsWeb,  filterByCompany: true, companyId: loggedInUser.companyId })
        );
        return BluebirdPromise.all(promises).then(() => getRecommendedAndAssignedCollections({pathsContext: this.context.pathsWeb}));
    };

    onCollectionCardClick = (collection) => {
        this.setState({
            collectionIdToRecommend: collection.collectionId || collection._id
        });
    };

    handleRecommendationModalOpen = () => {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
    };

    _calculateJourneyColumnHeight = () => {
        const { completedUserCollections, inProgressUserCollections, recommendedAndAssignedCollections } = this.props;
        let collectionRowCount = 0;
        if (completedUserCollections.length) {
            collectionRowCount += 1;
        }
        if (inProgressUserCollections.length) {
            collectionRowCount += 1;
        }
        if (recommendedAndAssignedCollections.length) {
            collectionRowCount += 1;
        }
        return `${490 * collectionRowCount + 460}px`;
    };

    // _togglePanel = () => {
    //     const { isHomePageLearningPanelOpen: isOpen } = this.state;
    //     const isHomePageLearningPanelOpen = isOpen ?? true;
    //     setLocalStorage({
    //         key: 'isHomePageLearningPanelOpen',
    //         value: !isHomePageLearningPanelOpen,
    //         dispatchDisabled: true
    //     });
    //     this.setState({ isHomePageLearningPanelOpen: !isHomePageLearningPanelOpen }, () => {
    //         const isPanelOpen = this.state.isHomePageLearningPanelOpen;
    //         document.body.style.overflowY = !isPanelOpen ? 'auto' : 'hidden';
    //     });
    // };

    _getCollectionRowCount = (categories) => {
        let collectionRowCount = 0;
        categories.forEach((category) => {
            if (
                category.type === 'COLLECTION' ||
                category.type === 'RECOMMENDED_COLLECTIONS' ||
                category.type === 'IN_PROGRESS_SECTION' ||
                category.type === 'COMPLETED_COLLECTIONS' ||
                category.type === 'GLOBAL_CONTENT_ROW'
            ) {
                collectionRowCount += 1;
            }
        });

        return collectionRowCount;
    };

    _popularOnPathsRow = () => {
        const { collectionsById, userCollectionsByCollectionId, userCollectionLoading } = this.props;

        const collectionOrder = POPULAR_ON_PATHS_ROW.content.reduce((collectionMap, collection) => {
            collectionMap[collection.id] = collection.order
            return collectionMap
        }, {})

        const collectionData = POPULAR_ON_PATHS_ROW.content.reduce((acc, collectionObj) => {
            const userCollection = userCollectionsByCollectionId[collectionObj.id];
            const collection = collectionsById[collectionObj.id];
            if (userCollection) {
                acc.push({...userCollection, orderId: collectionObj.order });
            } else if (collection) {
                acc.push({...collection, orderId: collectionObj.order});
            }
            return acc
        }, []);

        if (!collectionData || collectionData.length === 0) {
            return null
        }

        collectionData.sort((a, b) => {
            const orderA = collectionOrder[a.id] || collectionOrder[a.collectionId];
            const orderb = collectionOrder[b.id] || collectionOrder[b.collectionId];
            return orderA - orderb
        })

        return (
            <CollectionsHomeRow
                className={'due-collections-row'}
                labelTextId={'POPULAR_ON_PATHS'}
                labelDefaultMessage={'Popular on Paths'}
                loading={userCollectionLoading}
                userCollections={collectionData}
                collections={[]}
                onCardClick={this.onCollectionCardClick}
                handleRecommendationModalOpen={this.handleRecommendationModalOpen}
                customAccessor={[orderAccessor]}
            />
        )
    }

    _createCategoryRows = () => {
        const {
            completedUserCollections,
            inProgressUserCollections,
            userCompany,
            userCompany: { customHome = {} },
            userTeams = [],
            isVerbAdmin,
            frameworkDimensions = [],
            collectionsById,
            userCollectionsByCollectionId,
            collectionLoading,
            userCollectionLoading,
            history,
            recommendedAndAssignedCollections,
            userLearningAssetsById = {}
        } = this.props;

        let homePageRows;

        if (customHome.categories && customHome.categories.length) {
            homePageRows = customHome.categories;
        } else {
            homePageRows = DEFAULT_CUSTOM_HOME_PAGE.categories.slice(1);
        }

        const { currentWidth } = this.state;
        const blankCollectionCard = <div className={'blank-collection-card-content'} />;

        const findCollectionCard = (
            <div
                key={'findColCard'}
                onClick={() => history.push('/discover')}
                className={'vertical-collection-card find-collection-card col-12'}
            >
                <div className={'content'}>
                    <div className={'icon-container'}>
                        <i className={'fal fa-fw fa-plus'} />
                        <div className={'text-container'}>
                            <VerbText messageId={'FIND_A_PATH'} defaultMessage={'Find a Path'} />
                        </div>
                    </div>
                </div>
            </div>
        );

        const rowsToReturn = homePageRows.map((category, index) => {
            if (category.type === 'FEATURED_COLLECTION') {
                const rowLabel =
                    category.label.toLowerCase() === 'featured collection' || category.label === ''
                        ? `FEATURED COLLECTION FOR ${userCompany.name.toUpperCase()}`
                        : category.label;
                return (
                    <FeaturedCollectionRow
                        collectionSubtitle={category.subtext || ''}
                        collection={
                            userCollectionsByCollectionId[category.content[0]] ||
                            collectionsById[category.content[0]] ||
                            {}
                        }
                        className={'featured-collection-row'}
                        durationInMinutes={(collectionsById[category.content[0]] || {}).durationInMinutes}
                        labelDefaultMessage={rowLabel}
                        labelTextId={' '}
                        handleRecommendationModalOpen={this.handleRecommendationModalOpen}
                        recommendationInfo={(collectionsById[category.content[0]] || {}).recommendationInfo}
                    />
                );
            }
            if (category.type === 'COLLECTION' || category.type === 'GLOBAL_CONTENT_ROW') {
                return (
                    <CollectionsHomeRow
                        className={'custom-collections-row'}
                        labelTextId={' '}
                        labelDefaultMessage={category.label}
                        subtext={category.subtext}
                        isCollectionsOrderLocked={category.isOrderLocked}
                        loading={collectionLoading}
                        collections={category.content.map(
                            (collectionId) =>
                                userCollectionsByCollectionId[collectionId] || collectionsById[collectionId] || {}
                        )}
                        onCardClick={this.onCollectionCardClick}
                        handleRecommendationModalOpen={this.handleRecommendationModalOpen}
                        key={`${category.type}-${index}`}
                    />
                );
            }
            if (category.type === 'PRESET_DIMENSIONS_SECTION') {
                return (
                    <DimensionsHomeRow
                        dimensions={frameworkDimensions}
                        labelTextId={category.label ? ' ' : 'HUMAN_CENTERED_LEADERSHIP_DEVELOPMENT'}
                        labelDefaultMessage={category.label || 'Human-centered Leadership Development'}
                        loading={collectionLoading}
                        subtext={category.subtext}
                        className={'dimension-row'}
                        key={`${category.type}-${index}`}
                    />
                );
            }
            if (
                category.type === 'RECOMMENDED_COLLECTIONS' &&
                recommendedAndAssignedCollections &&
                recommendedAndAssignedCollections.length
            ) {
                return (
                    <CollectionsHomeRow
                        className={'due-collections-row ASSIGNED_AND_RECOMMENDED'}
                        labelTextId={'ASSIGNED_AND_RECOMMENDED'}
                        labelDefaultMessage={'Assigned and Recommended'}
                        loading={userCollectionLoading}
                        userCollections={recommendedAndAssignedCollections}
                        collections={[]}
                        onCardClick={this.onCollectionCardClick}
                        handleRecommendationModalOpen={this.handleRecommendationModalOpen}
                        key={`${category.type}-${index}`}
                        skipSort={true}
                    />
                );
            }
            if (category.type === 'TEAMS_SECTION' && userTeams && userTeams.length) {
                return (
                    <TeamsHomeRow
                        userTeams={userTeams}
                        loading={collectionLoading}
                        onCardClick={(team) => {}}
                        key={`${category.type}-${index}`}
                    />
                );
            }
            if (category.type === 'IN_PROGRESS_SECTION') {
                let addons = [];
                if (!inProgressUserCollections.length && !this.state.loading) {
                    addons = [
                        findCollectionCard,
                        <div
                            key={'in-progress-blank-1'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>,
                        <div
                            key={'in-progress-blank-2'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>,
                        <div
                            key={'in-progress-blank-3'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>
                    ];
                    if (currentWidth <= 480) {
                        addons = [findCollectionCard];
                    }
                }

                return (
                    <CollectionsHomeRow
                        className={'in-progress-collections-row'}
                        labelTextId={'IN_PROGRESS'}
                        labelDefaultMessage={'In Progress'}
                        loading={userCollectionLoading}
                        userCollections={inProgressUserCollections}
                        onCardClick={this.onCollectionCardClick}
                        handleRecommendationModalOpen={this.handleRecommendationModalOpen}
                        key={`${category.type}-${index}`}
                        addons={addons}
                        userLearningAssetsById={userLearningAssetsById}
                        skipSort={true}
                    />
                );
            }
            if (
                category.type === 'COMPLETED_COLLECTIONS' &&
                !(currentWidth <= 480 && !completedUserCollections.length)
            ) {
                let addons = [];
                if (!completedUserCollections.length && !this.state.loading) {
                    addons = [
                        <div
                            key={'completed-blank-1'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>,
                        <div
                            key={'completed-blank-2'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>,
                        <div
                            key={'completed-blank-3'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>,
                        <div
                            key={'completed-blank-4'}
                            className={'vertical-collection-card blank-collection-card col-12'}
                        >
                            {blankCollectionCard}
                        </div>
                    ];
                }

                return (
                    <CollectionsHomeRow
                        className={'completed-collections-row'}
                        labelTextId={'COMPLETED_COLLECTIONS'}
                        labelDefaultMessage={'Completed'}
                        loading={userCollectionLoading}
                        userCollections={completedUserCollections}
                        onCardClick={this.onCollectionCardClick}
                        handleRecommendationModalOpen={this.handleRecommendationModalOpen}
                        key={`${category.type}-${index}`}
                        addons={addons}
                        skipSort={true}
                    />
                );
            }
            return null;
        });

        return <>{rowsToReturn}</>;
    };


    render() {
        const {
            userCompany,
            isVerbAdmin,
            isAccountOwner,
            loggedInUser,
            teamsById,
            collectionsById,
            getManyUserEvents,
            postPeerRecommendations,
            postNotes,
            pathwaysEnabled,
            getManyPathways,
            getManyUserPathways,
            getPathway,
            getUserPathway,
            postUserPathway,
            putUserPathway,
            getManyUserCollections,
            userCollectionsById,
            userPathways,
            inProgressUserCollections,
            completedUserCollections,
            userCollectionLoading,
            collectionLoading,
            history,
            postUserFeedback,
            userCollectionsByCollectionId,
            recommendedAndAssignedCollections,
        } = this.props;
        const {
            loading,
            modalOpen,
            collectionIdToRecommend,
            // isHomePageLearningPanelOpen,
            currentWidth,
            displayFeedbackModule,
            feedbackPanelExtended,
            isAssignedRecommendedLoaded
        } = this.state;
        const { pathwayView = '', pathwayPermalink } = querystring.parse(history.location.search);
        const shouldShowWelcomeBanner =
            !completedUserCollections.length &&
            !inProgressUserCollections.some((userCollection) => userCollection.status === 'IN_PROGRESS') &&
            !userCollectionLoading &&
            userCompany._id;

        return (
            <Page
                id={'home-page'}
                className={'home-wrapper container-fluid home no-padding'}
                // onClick={() => {
                //     if (document.body.style.overflowY === 'hidden' && !isHomePageLearningPanelOpen) {
                //         document.body.style.overflowY = 'auto';
                //     }
                // }}
            >
                {/* {displayFeedbackModule && (
                    <FeedbackModule
                        updateProfile={updateProfile}
                        postUserFeedback={postUserFeedback}
                        userProfile={loggedInUser}
                        handleFeedbackClose={this.handleFeedbackClose}
                        userCompany={userCompany}
                        handleFeedbackExtended={this.handleFeedbackExtended}
                    />
                )} */}
                {/* <PanelWidget
                    homePageLoading={this.state.loading}
                    userProfile={loggedInUser}
                    isHomePageLearningPanelOpen={isHomePageLearningPanelOpen}
                    columnHeight={this._calculateJourneyColumnHeight()}
                    currentWidth={currentWidth || window.outerWidth}
                    getManyPathways={getManyPathways}
                    getManyUserPathways={getManyUserPathways}
                    getPathway={getPathway}
                    getUserPathway={getUserPathway}
                    collectionsById={collectionsById}
                    postUserPathway={postUserPathway}
                    putUserPathway={putUserPathway}
                    userCollectionsById={userCollectionsById}
                    getManyUserCollections={getManyUserCollections}
                    userCompany={userCompany}
                    userPathways={userPathways}
                    isVerbAdmin={isVerbAdmin}
                    getManyUserEvents={getManyUserEvents}
                    postNote={postNotes}
                    showNoteForm={true}
                    togglePanel={this._togglePanel}
                    pathwaysEnabled={pathwaysEnabled}
                    history={history}
                    teamsById={teamsById}
                    pathwayView={pathwayView}
                    displayFeedbackModule={displayFeedbackModule}
                    feedbackPanelExtended={feedbackPanelExtended}
                    pathwayPermalink={pathwayPermalink}
                /> */}
                <div ref={this.homeMainColumnRef} className={cns('home-main-column')}>
                    <ImproveSkillsWidget />
                    {userCompany._id && !isAssignedRecommendedLoaded && !recommendedAndAssignedCollections.length && this._popularOnPathsRow()}
                    {!loading && shouldShowWelcomeBanner && !userCompany.hideWelcomeBanner ? (
                        <HomeWelcomeBanner />
                    ) : null}
                    {userCompany._id && this._createCategoryRows()}
                    {userCompany._id && (isAssignedRecommendedLoaded || recommendedAndAssignedCollections.length > 0) && this._popularOnPathsRow()}
                </div>
                <RecommendationModal
                    isAccountOwner={isAccountOwner}
                    isVerbAdmin={isVerbAdmin}
                    isOpen={modalOpen}
                    onClose={this.handleRecommendationModalOpen}
                    parentId={collectionIdToRecommend}
                    onSend={postPeerRecommendations}
                    companyId={loggedInUser.companyId}
                    loggedInUser={loggedInUser}
                    currentUserEmail={loggedInUser.email}
                    parentType={'COLLECTION'}
                    teamsById={teamsById}
                    company={userCompany}
                    parentEntity={collectionsById[collectionIdToRecommend] || {}}
                />
            </Page>
        );
    }
}

export const makeMapStateToProps = () => {
    const getUserCollectionsObjectsFromStateById = makeGetUserCollectionByUser();
    const getUserCollectionContent = makeGetUserCollectionContent();
    const getUserActiveTeams = makeGetFilteredObjectsFromState('teams');
    const getUserPathwaysObjectsFromStateById = makeGetObjectsFromStateById('userPathways');
    const getFrameworks = makeGetFilteredObjectsFromState('learningFrameworks');

    const derivedMapStateToProps = (state, ownProps) => {
        const {
            auth: { isAuthenticated, isVerbAdmin, isAccountOwner, loggedInUser = {}, loggedInUserId },
            collections,
            userCollections,
            mobile: { isMobile },
            userLearningAssets,
            teams,
            companies,
            dimensions,
            learningFrameworks
        } = state;
        const { pathsContext  = {}} = ownProps;
        const userCompany =
            loggedInUser.companyId && companies && companies.byId[loggedInUser.companyId]
                ? companies.byId[loggedInUser.companyId]
                : {};

        const { pathwaysEnabled = false } = userCompany;

        // Show HomePage Panel

        // Collections. We should no longer be writing logic to gather collections user can access
        // User Collections
        let userCollectionContent;
        let userCollectionCompletenessData;

        const userCollectionsArray = getUserCollectionsObjectsFromStateById(state, loggedInUser._id);
        const userCollectionsWithCompletenessData = userCollectionsArray.map((userCollection) => {
            userCollectionContent = getUserCollectionContent(userCollection, state);
            userCollectionCompletenessData = getCompletionStatusForUserCollection(userCollectionContent);
            return {
                ...userCollection,
                ...userCollectionCompletenessData,
                totalLearningAssets:
                    userCollectionCompletenessData.totalLearningAssets ||
                    (userCollection.content && userCollection.content.length)
            };
        });
        const { recommendedIds = [], assignedIds = [], byId } = collections;
        const userCollectionsByCollectionId = keyBy(userCollectionsWithCompletenessData, 'collectionId');

        const recommendedAndAssignedCollections = [...recommendedIds, ...assignedIds]
            .reduce((acc, collection) => {
                const { _id, recommendationCount, isRecommended, isAssigned, isRecommendedByTeamLead, recommendationInfo, dateRecommended } = collection;
                if (byId[_id]?.isActive) {
                    acc.push({
                        ...(userCollectionsByCollectionId[_id] || byId[_id]),
                        recommendationCount,
                        isRecommended,
                        isAssigned,
                        isRecommendedByTeamLead,
                        recommendationInfo,
                        dateRecommended
                    });
                }
                return acc;
            }, [])
            .sort((a, b) => new Date(b.dateRecommended) - new Date(a.dateRecommended));

        const completedUserCollections = userCollectionsWithCompletenessData
            .filter((userCollection) =>
                collections.byId[userCollection.collectionId]?.isActive &&
                (userCollection.status === 'COMPLETED' || userCollection.percentComplete === 100)
            )
            .sort((a, b) => new Date(b.completedOn) - new Date(a.completedOn));

        const inProgressUserCollections = userCollectionsWithCompletenessData
            .filter((userCollection) =>
                collections.byId[userCollection.collectionId]?.isActive &&
                (userCollection.status === 'IN_PROGRESS' || (userCollection.percentComplete < 100 && userCollection.percentComplete > 0)) &&
                userCollection.type !== 'COLLAB'
            )
            .sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn));

        // Learning framework
        let learningFramework;
        if (
            userCompany &&
            userCompany.hasCustomDimensions &&
            userCompany.frameworkId &&
            learningFrameworks.byId[userCompany.frameworkId]
        ) {
            learningFramework = learningFrameworks.byId[userCompany.frameworkId];
        } else {
            const [defaultFramework] = getFrameworks(state, (framework) => !!framework.isDefault);
            if (defaultFramework) {
                learningFramework = defaultFramework;
            }
        }

        let frameworkDimensions = [];

        if (learningFramework && learningFramework.dimensionIds) {
            learningFramework.dimensionIds.forEach((id) => {
                const dimension = dimensions.byId[id];
                if (dimension) {
                    if (learningFramework.primaryDimensionId && id === learningFramework.primaryDimensionId) {
                        dimension.isPrimary = true;
                    }
                    frameworkDimensions.push(dimension);
                }
            });
        } else {
            frameworkDimensions = Object.values(dimensions.byId);
        }
        const userTeams = [];
        if (loggedInUser.teams && teams.byId) {
            loggedInUser.teams.forEach((team) => {
                if (teams.byId[team.teamId] && teams.byId[team.teamId].isActive) {
                    userTeams.push({ ...teams.byId[team.teamId], joinedDateTime: team.joinedDateTime });
                }
            });
        }
        userTeams.sort((a, b) => new Date(b.joinedDateTime) - new Date(a.joinedDateTime));

        return {
            isAuthenticated,
            isVerbAdmin,
            isAccountOwner,
            loggedInUser,
            loggedInUserId,
            userCompany,
            isMobile,
            completedUserCollections,
            inProgressUserCollections,
            frameworkDimensions,
            userCollectionsByCollectionId,
            recommendedAndAssignedCollections,
            pathwaysEnabled,
            userTeams,
            collectionLoading: collections.loading,
            userCollectionLoading: userCollections.loading,
            userLearningAssetLoading: userLearningAssets.loading,
            userLearningAssetsById: userLearningAssets.byId,
            teamsById: teams.byId,
            collectionsById: collections.byId,
            userCollectionsById: userCollections.byId,
            userPathways: getUserPathwaysObjectsFromStateById(state)
        };
    };

    return derivedMapStateToProps;
};

export const mapDispatchToProps = (dispatch) => ({
    getManyCollections: (params) => dispatch(getManyCollections(params)),
    getManyUserLearningAssets: (params) => dispatch(getManyUserLearningAssets(params)),
    getManyUserCollections: (params) => dispatch(getManyUserCollections(params)),
    postPeerRecommendations: (params) => dispatch(postPeerRecommendations(params)),
    getManyUserEvents: (params) => dispatch(getManyUserEvents(params)),
    postNotes: (params) => dispatch(postNotes(params)),
    getManyUserPathways: (params) => dispatch(getManyUserPathways(params)),
    getManyPathways: (params) => dispatch(getManyPathways(params)),
    getPathway: (params) => dispatch(getPathway(params)),
    getUserPathway: (params) => dispatch(getUserPathway(params)),
    postUserPathway: (params) => dispatch(postUserPathway(params)),
    putUserPathway: (params) => dispatch(putUserPathway(params)),
    getRecommendedAndAssignedCollections: (params) =>
        dispatch(getRecommendedAndAssignedCollections(params)),
    postUserFeedback: (params) => dispatch(postUserFeedback(params)),
});

export const HomeComponent = Home;
export default connect(makeMapStateToProps, mapDispatchToProps)(Home);
